export const UPDATE_ALTRO = 'UPDATE_ALTRO';